import { type FC } from 'react'
import { CookiePreferences } from '../CookiePreferences/CookiePreferences'
import { type CookiePolicyProps } from './CookiePolicy.interface'
import { RichText } from '~/components/RichText/RichText'
import styles from './CookiePolicy.module.scss'

export const CookiePolicy: FC<CookiePolicyProps> = ({
  title,
  text,
  statusHeading,
  essentialCookiesHeading,
  essentialCookiesDescription,
  analyticsCookiesHeading,
  analyticsCookiesDescription,
  personalisationCookiesHeading,
  personalisationCookiesDescription,
  richText
}) => {
  const handleToggleCookie = (name: boolean): void => {}
  const preferences = [
    {
      name: 'essential' as const,
      isNecessary: true,
      title: essentialCookiesHeading,
      description: essentialCookiesDescription,
      togglePreferenceCookie: handleToggleCookie
    },
    {
      name: 'analytics' as const,
      isNecessary: false,
      title: analyticsCookiesHeading,
      description: analyticsCookiesDescription,
      togglePreferenceCookie: handleToggleCookie
    },
    {
      name: 'personalisation' as const,
      isNecessary: false,
      title: personalisationCookiesHeading,
      description: personalisationCookiesDescription,
      togglePreferenceCookie: handleToggleCookie
    }
  ]

  return (
    <div className="wrapper wrapper-bottom ">
      <div className={styles.container}>
        <CookiePreferences
          title={title}
          intro={text}
          preferences={preferences}
          statusHeading={statusHeading}
        />
        {
        richText && <RichText className="container" richtext={richText.richtext} />
      }
      </div>
    </div>
  )
}
